import { Moment } from 'moment';
import { EventStatus } from '../../events/event.types';

export enum AutoSearchResultType {
	Customer = 0,
	Event = 1
}

export class AutoSearchResult {
	id: number;
	type: AutoSearchResultType;
	name: string;
}

export class CustomerAutoSearchResult extends AutoSearchResult {
	type: AutoSearchResultType = AutoSearchResultType.Customer;
	email?: string;
	phone?: string;
	secondaryEmail?: string;
	secondaryPhone?: string;
}

export class EventAutoSearchResult extends AutoSearchResult {
	type: AutoSearchResultType = AutoSearchResultType.Event;
	extendedEventId: string;
	status: EventStatus;
	startsOn?: Moment | string;
	endsOn?: Moment | string;
	isSingleDay?: boolean;
	legacyBookingId?: number;
}
